import axios from "axios";
import Swal from "sweetalert2";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";

export default function GoogleLoginAuthButton() {

    const navigate = useNavigate();

    const login = useGoogleLogin({
        flow: "implicit",

        onSuccess: async (tokenResponse) => {

            try {

                // Get Google user information
                const googleUser = await axios.get(
                    "https://www.googleapis.com/oauth2/v3/userinfo",
                    {
                        headers: {
                            Authorization: `Bearer ${tokenResponse.access_token}`,
                        },
                    }
                );

                // Call your backend
                const resp = await axios.post(
                    process.env.REACT_APP_API + "/google-login",
                    {
                        email: googleUser.data.email,
                        google_id: googleUser.data.sub,
                    }
                );

                if (resp.data.msgcode === 1) {

                    localStorage.setItem("pid", resp.data.profileid);

                    Swal.fire({
                        icon: "success",
                        title: "Welcome",
                        text: resp.data.msg,
                        confirmButtonColor: "#900b06",
                        timer: 1500,
                        showConfirmButton: false,
                    }).then(() => {
                        navigate("/dashboard");
                    });

                } else {

                    Swal.fire({
                        icon: "error",
                        title: "Google Login Failed",
                        text: resp.data.msg,
                        confirmButtonColor: "#900b06",
                    });

                }

            } catch (err) {

                Swal.fire({
                    icon: "error",
                    title: "Google Login Failed",
                    text:
                        err.response?.data?.msg ||
                        "Unable to login. Please try again.",
                    confirmButtonColor: "#900b06",
                });

            }

        },

        onError: () => {

            Swal.fire({
                icon: "error",
                title: "Cancelled",
                text: "Google Sign-In cancelled.",
                confirmButtonColor: "#900b06",
            });

        },
    });

    return (
        <div className="d-flex justify-content-center mt-3">
            <button
                type="button"
                onClick={() => login()}
                className="btn bg-white border shadow-sm d-flex align-items-center justify-content-center"
                style={{
                    width: "350px",
                    height: "44px",
                    borderRadius: "22px",
                    fontWeight: "500",
                    color: "#3c4043",
                    border: "1px solid #dadce0",
                }}
            >
                <img
                    src="https://developers.google.com/identity/images/g-logo.png"
                    alt="Google"
                    width="20"
                    height="20"
                    className="me-2"
                />
                Sign in with Google
            </button>
        </div>
    );
}